import { isAPIError, put } from '@user/store/services/crud'
import { urls } from '../constants'
import type { Activity } from '../typings'
import { toast } from '@sales-center/components'
import { Actions, updateActivityActionCreator } from '../state'

export async function updateActivityEffect(
  activity: Activity,
): Promise<Actions | undefined> {
  const response = await put(urls.upsert, activity)

  if (!response.ok) {
    // The API error envelope is flat — { StatusCode, Message } straight from
    // ExceptionMiddleware — so there is no `payload` to read (reading one made
    // isAPIError(undefined) throw, so a failed save rejected before the toast and
    // the return below). The body can also be non-JSON (an HTML/empty 5xx) or, on
    // a transport failure, a plain string from the CRUD helper; none of those may
    // throw, they all fall back to the generic message.
    const error = await response.json().catch(() => undefined)
    toast.error(
      error != null && isAPIError(error)
        ? error.Message
        : 'Failed to update Activity',
    )

    // SH-1432: return undefined (not an empty action) on failure, mirroring
    // createActivityEffect. The shared ActivityForm handler treats a truthy
    // action as success — dispatching the update reducer, running the
    // parent-date side effect and firing onSuccess (which closes the calendar
    // Edit modal). A failed save must do none of those (AC-8.1): keep the modal
    // open with input intact and leave every surface unchanged. Note: this
    // collapses a 404 (AC-8.4) into the same generic-failure path — the modal
    // stays open with an error toast rather than closing + refreshing the
    // calendar — an accepted Option-B limitation (no {ok,status,data}
    // discrimination in the reused effect).
    return undefined
  }

  return updateActivityActionCreator(await response.json())
}
